import axios from 'axios';

import { getLocale } from 'src/packages/utils/get-locale';
import { getAccessToken } from 'src/services/auth-service/auth';
import { UserServiceNS } from 'src/services/auth-service/user-service';

import { VITE_GATEWAY_URL } from './consts';

const gatewayAgent = axios.create({
  baseURL: VITE_GATEWAY_URL,
  headers: {
    'content-type': 'application/json',
  },
});

gatewayAgent.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error?.response?.status === 401) {
      const accessToken = await UserServiceNS.updateToken();

      if (error?.config && accessToken) {
        return axios.request({
          ...error.config,
          headers: {
            ...error.config.headers,
            Authorization: `Bearer ${accessToken}`,
          },
        });
      }
    }

    return Promise.reject(error);
  },
);

gatewayAgent.interceptors.request.use((config) => {
  const accessToken = getAccessToken();

  Object.entries(config.headers).forEach(([headerName, headerValue]) => {
    config.headers.set(headerName, headerValue);
  });

  config.headers['accept-language'] ??= getLocale();

  if (accessToken) {
    config.headers.Authorization = `Bearer ${accessToken}`;
  }

  return config;
});

export { gatewayAgent };
